import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { instagramUrl } from '../data/content';
export function Footer() {
  return <footer className="border-t border-ivory/10 bg-charcoal px-4 py-12" data-id="element-63" data-mp="3ggk7gsifd7yh">
      <div className="mx-auto max-w-4xl text-center" data-id="element-64" data-mp="32ovvcp86ejhi">
        <p className="font-display text-lg font-black uppercase tracking-[.2em] text-gold" data-id="element-65" data-mp="36pft9v0kpr4p">
          Bright Digital Hub
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-ivory/75" data-id="element-66" data-mp="3uesc7mlpddk7">
          Digital resources and professional programming tools for coaches and fitness
          professionals.
        </p>
        <p className="mt-5 font-display text-sm font-black uppercase text-ivory" data-id="element-67" data-mp="3ldanxgy565kf">
          Complete Stretching System 2026
        </p>
        <div className="mt-6 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-ivory/80 sm:flex-row sm:gap-6" data-id="element-68" data-mp="3qfjj8jyhljpp">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-gold" href="mailto:compradigitalyaa@gmail.com" data-id="element-69" data-mp="2eyt6sj3gzvnn">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="3gapb9dmj6adc" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-gold" href={instagramUrl} target="_blank" rel="noopener noreferrer" data-id="element-71" data-mp="3v7gha5qpmkbx">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="81pfbipu2x9d" /> Bright Digital Hub
          </a>
        </div>
        <div className="mt-8 border-t border-ivory/10 pt-6" data-id="element-73" data-mp="33e3x3jw4ep1">
          <p className="font-display text-base font-black uppercase leading-snug text-ivory" data-id="element-74" data-mp="ht39daz0n4v4">
            One complete year of stretching.
            <br data-id="element-75" data-mp="cuik26lay5lg" />
            <span className="text-gold" data-id="element-76" data-mp="cw34h3dwk85l">Week by week. Class by class.</span>
          </p>
          <p className="mt-5 text-xs text-ivory/55" data-id="element-77" data-mp="qrfai6xidl1t">
            © Bright Digital Hub 2026 — All Rights Reserved.
            <br data-id="element-78" data-mp="mq3jpy2wets1" />
            Unauthorized reproduction, resale or redistribution of this material without express
            permission is prohibited.
          </p>
        </div>
      </div>
    </footer>;
}